import Image      from "_components/atoms/image";
import Typography from "_components/atoms/typography";
import useStyles  from "_styles/molecules/tvLoginPopup";

const steps = [
	"Enter this code, available on your TV app."
];

const component = () => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div
			className = { classes.container }
		>
			<div className = { classes.instructions }>
				{steps.map ( ( stepText, idx ) => (
					<Typography
						key       = { idx }
						className = { classes.stepText }
						title     = { `${ stepText } ` }
					/>
				)
				)}
			</div>

			<Image
				alt       = "tv-login-info"
				className = { classes.image }
				src       = { "/images/tv-login-info.webp" }
			/>
		</div>

	);
};

export default component;
